import { Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from '../../core/services/language.service';
import { MAX_DATE } from '../constants/max-date.const';
import { DueAtDateTimeInfo } from '../contract/due-date-info-date-time.contract';
import { DueDateInfo } from '../contract/due-date-info.contract';
import { FormatDateTimePipe } from './format-date-time.pipe';

@Pipe({
  name: 'dueDate',
  standalone: true,
})
export class DueDatePipe implements PipeTransform {
  private circaAbbr = this.languageService.getInstant('general.circa.abbr');

  constructor(
    private languageService: LanguageService,
    private formatDateTimePipe: FormatDateTimePipe,
  ) {}

  public transform(dueDateInfo: DueDateInfo | DueAtDateTimeInfo): string {
    if (dueDateInfo && dueDateInfo.dueDate && this.notMaxDate(dueDateInfo.dueDate)) {
      return [
        dueDateInfo.dueDateEstimated ? this.circaAbbr : null,
        this.formatDateTimePipe.transform(dueDateInfo.dueDate),
      ]
        .filter(Boolean)
        .join(' ');
    }

    return '';
  }

  private notMaxDate(date: string): boolean {
    return date.indexOf(MAX_DATE) === -1;
  }

}
